module.exports = __webpack_public_path__ + "img/BS.74e23284.png";